import {
  Box as MantineBox,
  type BoxProps as MantineBoxProps,
} from "@mantine/core";
import type { CoreComponentProps, PolymorphicProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type BoxProps = CoreComponentProps<MantineBoxProps, 'div'> &
  PolymorphicProps;

export function Box({ testId, view = "all", ...rest }: BoxProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineBox data-testid={testId} {...(rest as MantineBoxProps)} />;
}
